import { GlobalResponseObject } from "@gtpl/shared-models/common-models";

export class AssignForCookingResponse extends GlobalResponseObject {
    data?: boolean;
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: boolean) {
        super(status, intlCode, internalMessage)
        this.data = data;
    }
}